"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileItem = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _SvgBtDelete = require("../svg/icons/SvgBtDelete");

var _iconButton = require("../icon-button");

var _spinner = require("../spinner");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _classnames = _interopRequireDefault(require("classnames"));

var _loadStyles = _interopRequireDefault(require("load-styles"));

(0, _loadStyles.default)(".cca57dbfd{display:flex;align-items:center;height:1.75rem}.c42f7a413{padding-right:.6rem;font-size:.875rem;font-weight:500;line-height:1rem;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.c46437124{min-width:1.75rem;width:1.75rem}.c85ce2f05 .c42f7a413{color:var(--color-flomni-gray-90)}.c1e308edc{display:flex}");
var styles = {
  root: 'cca57dbfd',
  name: 'c42f7a413',
  icon: 'c46437124',
  '--status-loading': 'c85ce2f05',
  '--status-loaded': 'c1e308edc'
};

var FileItem = function FileItem(props) {
  var name = props.name,
      onDelete = props.onDelete,
      status = props.status,
      classes = props.classes;
  var cn = (0, _useStyles.useStyles)(styles, classes);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(cn.root, cn.status[status])
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.name
  }, name), status === 'loading' ? /*#__PURE__*/_react.default.createElement("div", {
    className: cn.icon
  }, /*#__PURE__*/_react.default.createElement(_spinner.Spinner, null)) : /*#__PURE__*/_react.default.createElement(_iconButton.IconButton, {
    onClick: onDelete
  }, /*#__PURE__*/_react.default.createElement(_SvgBtDelete.SvgBtDelete, null)));
};

exports.FileItem = FileItem;
var status = ['loading', 'loaded'];
FileItem.modes = {
  status: status
};
FileItem.propTypes = {
  /* component logic props */
  name: _propTypes.string.isRequired,
  status: (0, _propTypes.oneOf)(status),
  onDelete: _propTypes.func.isRequired,

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
FileItem.defaultProps = {
  status: 'loaded',
  classes: {}
};